import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.174 1.333a5.333 5.333 0 0 0-5.333 5.334c0 3.6 4.7 7.666 4.9 7.84a.67.67 0 0 0 .867 0c.233-.174 4.9-4.24 4.9-7.84a5.333 5.333 0 0 0-5.334-5.334m0 11.767c-1.42-1.333-4-4.207-4-6.433a4 4 0 1 1 8 0c0 2.226-2.58 5.106-4 6.433m0-9.1a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333m0 4a1.333 1.333 0 1 1 0-2.667 1.333 1.333 0 0 1 0 2.667"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })